import styled from "styled-components";

const Button = styled.button<{height: number, width?: number}>`
  font: 16px "Euclid Circular A", sans-serif;
  font-weight: 400;
  line-height: 24px;
  color: #050505;
  background: #F0ECEB;
  height: ${props => props.height}px;
  width: ${props => props.width}px;
  border: none;
  cursor:pointer;
  border-radius: ${props => props.height / 2}px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  align-items: center;
  margin: 0;

  &:hover {
    background: #E6E2E1;
  }

  &:focus {
    outline:0;
  }
`;

const ActionButton = styled(Button)`
  color: #FAF8F7;
  background: #FF723A;

  &:hover {
    background: #FF9670;
  }
`;

const ColoredAcionButton = styled(Button)`
  color: #FF723A;
  background: #FAF8F7;

  &:hover {
    background: #FAF8F7;
  }
`;

const ButtonIcon = styled.div<{icon: string, tint: string}>`
  width: 24px;
  height: 24px;
  padding-left: 8px;
  padding-right: 8px;
  color: ${props => props.tint};
  background: url(${props => props.icon}) no-repeat center;
  background-size: 24px;

  @media only screen and (max-width: 768px) {
    
  }
`;

export { Button, ActionButton, ColoredAcionButton, ButtonIcon }